/**
 * Map of the different hlaa states
 * @constant
 * @default 0 Continue
 * @default 1 Threshold Found
 * @default 2 Reinstruct
 * @default 3 Threshold Found
 * @default 4 Max Presented Tone
 * @default 5 Constant Zero Tone Heard
 * */
export var assessmentStateMap = {
    0: 'Continue',
    1: 'Threshold Found',
    2: 'Reinstruct',
    4: 'Max Presented Tone',
    5: 'Constant Zero Tone Heard'
};
/**
 * States of the special workflows
 * @constant
 * @default defaultValue [2, 4, 5]
 * */
export var specialWorkflowList = [2, 4, 5];
